module.exports = __webpack_public_path__ + "img/02-Eisai_BG.9a1da457.jpg";